// Consent-aware analytics - must load before any tracking scripts
import './js/analytics/consent-datalayer-manager.js';
import './dayjs.js';
import './js/sentry.js';

import * as Turbo from '@hotwired/turbo';
import { registerSvelteControllerComponents } from '@symfony/ux-svelte';

import 'core-js/actual/structured-clone';
import './css/main.scss';

// start the Stimulus application
import { startStimulusApp } from '@symfony/reprise/stimulus';

Turbo.session.drive = false;

// Registers Stimulus controllers from controllers.json and in the controllers/ directory
startStimulusApp();

const svelteSagaControllers = import.meta.glob(
    './svelte/saga/controllers/*.svelte',
    { eager: true },
);

// Create a custom context function that behaves like import.meta.webpackContext for registerSvelteControllerComponents to work
const customContext = function (key) {
    return customContext._components[key];
};

customContext._components = Object.fromEntries(
    Object.entries(svelteSagaControllers).map(([path, module]) => [
        path.replace('./svelte/saga/controllers', '.'),
        module,
    ]),
);

customContext.keys = function () {
    return Object.keys(this._components);
};

registerSvelteControllerComponents(customContext);
